import experiments from '../../common/constants/experiments'

export default {
  name: 'AudioJungle',
  abbreviation: 'AJ',
  domain: 'audiojungle.net',
  google_analytics_id: 'UA-11834194-4',
  google_remarketing_label: 'SQ7NCLWBugMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ambient music',
  assets_domains: {
    item_thumbnail: 'thumb-aj.s3.envato.com',
    item_image: 'image-aj.s3.envato.com'
  },
  feeds_categories: [
    '/category/music',
    '/category/music-packs',
    '/category/music-kits',
    '/category/sound',
    '/category/source-files',
    '/category/logos-idents'
  ],
  features: {
    /**
     * @description Is true, we collapse the tags filter for all category pages unless it's a bottom level category (no children)
     * @author Geoff Evason
     * @expires Never.  This is currently used by some markets and not others.
     */
    'collapse-tags-unless-bottom-category': true,

    /**
     * @description Decide whether to display v0 or v1 item cards in search results page.
     *   Should be removed when all markets will use v1 item card.
     * @author Pawel Galazka
     * @expires
     * @expires When all markets will use v1 item card
     */
    'v0-search-results': true,

    /**
     * @description Enrolls users into an experiment between V0 and V1/new item cards.
     * @author Luke Jones
     * @expires When all markets are using new item cards by default.
     */
    'v0-search-results:enrolment': true,

    /**
     * @description Decide whether to display v0 or v1 item cards in featured/popular items page.
     * @author Pawel Galazka
     * @expires When all markets will use v1 item card
     */
    'v0-featured-page': true,
    /**
     * @description
     * @author
     * @expires
     */
    'experiments:loading-cover': true
  },
  experiments_to_features: {
    [experiments.audioJungleNewItemCard]: {
      0: {
        'v0-search-results': true,
        narrowItemCard: false
      },
      1: {
        'v0-search-results': true,
        narrowItemCard: false
      },
      2: {
        'v0-search-results': false,
        narrowItemCard: true
      },
      3: {
        'v0-search-results': false,
        narrowItemCard: true
      }
    }
  }
}
